module.exports = __webpack_public_path__ + "img/fig02.ab81f226.jpg";